<template>
  <div
    class="flow-cursor"
    :class="{
      'flow-cursor__reverse': !isTopToBottom,
      'flow-cursor__start': isStartPoint,
    }"
  >
    <div class="flow-cursor__body"></div>
    <div class="flow-cursor__head" :class="{ 'flow-cursor__head-reverse': !isTopToBottom }">
      <div class="flow-cursor__line"></div>
      <div class="flow-cursor__triangle"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["isTopToBottom", "isStartPoint"],
};
</script>

<style lang="less" scoped>
@import "../../../../../assets/styles/variables.less";
.flow-cursor {
  display: flex;
  flex-direction: column;
  align-items: center;
  &__reverse {
    flex-direction: column-reverse;
  }
  &__body {
    width: 0.2rem;
    height: 0.6rem;
    background-color: @kk-color-primary-blue;
  }
  &__start &__body {
    background-color: @kk-color-gold;
  }
  &__head {
    display: flex;
    flex-direction: column;
    align-items: center;
    &-reverse {
      flex-direction: column-reverse;
    }
  }
  &__line {
    width: 0.2rem;
    height: 0.3rem;
    background-color: @kk-color-gold;
  }
  &__start &__line {
    background-color: @kk-color-primary-blue;
  }
  &__triangle {
    width: 8px;
    height: 8px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 8px solid @kk-color-gold;
    transform: rotate(180deg);
  }
  &__reverse &__triangle {
    width: 8px;
    height: 8px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 8px solid @kk-color-gold;
    transform: rotate(0deg);
  }
  &__start &__triangle {
    border-bottom-color: @kk-color-primary-blue;
  }
}
</style>
